export interface PlaygroundPanelSplitterProps {
  readonly ariaLabel: string;
  readonly active?: boolean;
  readonly onPointerDown: (event: React.PointerEvent<HTMLDivElement>) => void;
}

export function PlaygroundPanelSplitter({ ariaLabel, active, onPointerDown }: PlaygroundPanelSplitterProps) {
  return (
    <div
      role="separator"
      aria-orientation="vertical"
      aria-label={ariaLabel}
      tabIndex={0}
      className={`playground-panel-splitter${active ? " is-active" : ""}`}
      onPointerDown={onPointerDown}
    />
  );
}
